import { render, staticRenderFns } from "./step_description_epidemiological_control.vue?vue&type=template&id=db240794&scoped=true"
import script from "./step_description_epidemiological_control.vue?vue&type=script&lang=js"
export * from "./step_description_epidemiological_control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db240794",
  null
  
)

export default component.exports